import React from "react";

const FILTER_OPTS = [
  { value: "all", label: "All" },
  { value: "unread", label: "Unread" },
  { value: "hire", label: "Hire VBB" },
  { value: "pitch", label: "Pitch" },
  { value: "partner", label: "Partner" },
  { value: "hi", label: "Hi" },
];

export default function FilterChips({ filter, setFilter }) {
  return (
    <div className="mt-10 flex flex-wrap gap-2" data-testid="admin-filter-row">
      {FILTER_OPTS.map((opt) => (
        <button
          key={opt.value}
          onClick={() => setFilter(opt.value)}
          className={`font-mono-tiny px-3 py-2 border transition-colors ${
            filter === opt.value
              ? "bg-[#0a0a0a] text-[#fafafa] border-[#0a0a0a]"
              : "bg-transparent text-[#0a0a0a] border-[#0a0a0a] hover:bg-[#f4f4f5]"
          }`}
          data-testid={`admin-filter-${opt.value}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
